const FLOWERS = '1800flowers';
const SWAROVSKI = 'swarovski';

const MERCHANTS = {
  flowers: FLOWERS,
  swarovski: SWAROVSKI
};

const MAX_ALLOWED_CONTACT_COUNT_FCC = 'merchant.max-allowed-contact-count-with-credit-card';
const CONTACT_LIMIT_LIST = 'merchant.settings.max-recognition-contact-limit.contacts-type-list';
const CONTACT_LIMIT_NUMBER = 'merchant.settings.max-recognition-contact-limit.contacts-type-number';
const DEFAULT_CONTACT_LIMIT_LIST = 10000;
const DEFAULT_CONTACT_LIMIT_NUMBER = 25000;

const BANNERS = 'merchant.homepage.banners';
const HOME_TOP_CATEGORIES = 'merchant.homepage.chip-slider';
const CATEGORY_PRODUCT_SLIDER = 'merchant.homepage.category-product-slider';
const CATEGORY_FILTERS = 'merchant.product-list.category-filters';

export {
  CONTACT_LIMIT_LIST,
  CONTACT_LIMIT_NUMBER,
  DEFAULT_CONTACT_LIMIT_LIST,
  DEFAULT_CONTACT_LIMIT_NUMBER,
  MAX_ALLOWED_CONTACT_COUNT_FCC,
  MERCHANTS
};

export const MERCHANT_CONFIG = {
  banners: BANNERS,
  homeTopCategories: HOME_TOP_CATEGORIES,
  categoryProductSlider: CATEGORY_PRODUCT_SLIDER,
  categoryFilters: CATEGORY_FILTERS
};
